const base = {
  en: {
    'nav.dashboard': 'Dashboard',
    'nav.timeTracking': 'Time Tracking',
    'nav.projects': 'Projects',
    'nav.clients': 'Clients',
    'nav.billing': 'Billing',
    'nav.team': 'Team',

    'layout.profile': 'Profile',
    'layout.settings': 'Settings',
    'layout.signOut': 'Sign Out',

    'settings.title': 'Settings',
    'settings.subtitle': 'Manage your preferences',
    'settings.save': 'Save',
    'settings.saved': 'Settings saved',
    'settings.reset': 'Reset',
    'settings.resetDone': 'Settings reset to defaults',

    'settings.appearance': 'Appearance',
    'settings.theme': 'Theme',
    'settings.themeLight': 'Light',
    'settings.themeDark': 'Dark',
    'settings.themeSystem': 'System',
    'settings.language': 'Language',

    'settings.regional': 'Regional',
    'settings.dateFormat': 'Date format',
    'settings.weekStart': 'Week starts on',
    'settings.weekStartSunday': 'Sunday',
    'settings.weekStartMonday': 'Monday',
    'settings.timezone': 'Timezone',

    'settings.timeTracking': 'Time Tracking',
    'settings.defaultHourlyRate': 'Default hourly rate',
    'settings.roundTo': 'Round time to',
    'settings.roundNone': 'No rounding',
    'settings.round5': 'Nearest 5 minutes',
    'settings.round15': 'Nearest 15 minutes',

    'settings.notifications': 'Notifications',
    'settings.emailNotifications': 'Email notifications',
    'settings.weeklySummary': 'Weekly summary',
  },

  es: {
    'nav.dashboard': 'Panel',
    'nav.timeTracking': 'Control de tiempo',
    'nav.projects': 'Proyectos',
    'nav.clients': 'Clientes',
    'nav.billing': 'Facturación',
    'nav.team': 'Equipo',

    'layout.profile': 'Perfil',
    'layout.settings': 'Configuración',
    'layout.signOut': 'Cerrar sesión',

    'settings.title': 'Configuración',
    'settings.subtitle': 'Administra tus preferencias',
    'settings.save': 'Guardar',
    'settings.saved': 'Configuración guardada',
    'settings.reset': 'Restablecer',
    'settings.resetDone': 'Configuración restablecida',

    'settings.appearance': 'Apariencia',
    'settings.theme': 'Tema',
    'settings.themeLight': 'Claro',
    'settings.themeDark': 'Oscuro',
    'settings.themeSystem': 'Sistema',
    'settings.language': 'Idioma',

    'settings.regional': 'Regional',
    'settings.dateFormat': 'Formato de fecha',
    'settings.weekStart': 'La semana empieza en',
    'settings.weekStartSunday': 'Domingo',
    'settings.weekStartMonday': 'Lunes',
    'settings.timezone': 'Zona horaria',

    'settings.timeTracking': 'Control de tiempo',
    'settings.defaultHourlyRate': 'Tarifa por hora predeterminada',
    'settings.roundTo': 'Redondear el tiempo a',
    'settings.roundNone': 'Sin redondeo',
    'settings.round5': '5 minutos más cercanos',
    'settings.round15': '15 minutos más cercanos',

    'settings.notifications': 'Notificaciones',
    'settings.emailNotifications': 'Notificaciones por correo',
    'settings.weeklySummary': 'Resumen semanal',
  },
};

export default base;
